export const REDEEM_LOYALTY_POINTS = 'REDEEM_LOYALTY_POINTS';
export const REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS';
export const FETCH_LOYALTY_POINTS = 'FETCH_LOYALTY_POINTS';